export var initialState = {
  isAuthenticated: false,
  isInitialized: false,
  isReady: false,
  user: null,
  logoutRedirect: false
};